import _ from 'lodash'
import i18n from './i18n'
import Dataset from 'scoreboard/datasets/model/dataset'
const { BLANK } = Dataset
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'

/**
 * Escapes and Highlights some text to differentiate it from other text displayed to the
 * user.
 *
 * @param {String} text the text to be highlighted
 *
 * @param {Object} opts
 *
 * @param {Boolean} [opts.preserveLineBreaks=false] indicates whether we should preserve
 * line breaks when escaping the text
 */
function highlight(text, opts={}) {
	const textHtml = opts.preserveLineBreaks ? escapePreserveLineBreaks(text) :
		// Use 'common.list.1' so that it treats the text as a replacement, so it isn't affected
		// by configurable terminology
		_.escape(i18n.get('common.list.1', text))

	// If this is a blank value, mark it as one, so it can be styled properly
	if (textHtml === BLANK) {
		return '<span class="highlight blank-value">' + i18n.get('common.blank') + '</span>'
	}

	return '<span class="highlight">' + textHtml + '</span>'
}

export default highlight

highlight.__filename__ = 'components/highlight.js'
